export default __webpack_public_path__ + "static/slider-4-e0f5f9bb445337e6034234e903e0b607.jpg";